export default {
  methods: {
    detectOutsideClick({ target }) {
      if (
        // Firefox
        (target.nodeName === "ONS-MODAL" &&
          target.classList.contains("modal")) ||
        // Chrome
        (target.nodeName === "DIV" &&
          target.classList.contains("modal__content"))
      ) {
        if (this.cleanupModal !== undefined) {
          this.cleanupModal()
        }

        if (this.closeModal !== undefined) {
          this.closeModal()
        }
      }
    }
  }
}
